import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import BankAccountDetailViewModel from "viewModels/finance/bankAccounts/bankAccountDetailViewModel";
import EditableDetailView from "../../common/editableDetailView";
import BankAccountForm from "./bankAccountForm";

const BankAccountDetailView: ViewComponent<BankAccountDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<BankAccountForm vm={vm} />} />;
});

registerView(BankAccountDetailView, BankAccountDetailViewModel);
